// NPM
import { defineStore } from 'pinia';

// Services
import Api from '@/services/api';

// Stores
import { useUserStore } from '@/stores/user';
import type { UserDashboardGetAllEventsResponseType } from '@magma-app/magma-types/all';

export const useEventsStore = defineStore('events', {
  state: () => {
    return {
      availableEvents: [] as UserDashboardGetAllEventsResponseType['available'],
      completedEvents: [] as UserDashboardGetAllEventsResponseType['validated'],
      uncompletedEvents: [] as UserDashboardGetAllEventsResponseType['ongoing'],
      displayCompletedEventDetails: false,
      displayEventDetails: false,
    };
  },

  actions: {
    setCompletedEventDetails(displayCompletedEventDetails: boolean) {
      this.displayCompletedEventDetails = displayCompletedEventDetails;
    },

    setEventDetails(displayEventDetails: boolean) {
      this.displayEventDetails = displayEventDetails;
    },

    async getEvents() {
      const response = await Api.userDashboard().events.getEvents();

      this.completedEvents = response.data.validated;
      this.uncompletedEvents = response.data.ongoing;
      this.availableEvents = response.data.available;
    },
  },
});
